//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ATTRIBUTE_TYPE, ATTRIBUTE_ICON } from '../../../constants/global';
import ProductsAtGlanceItem from './ProductsAtGlanceItem.vue';

export default {
  components: {
    ProductsAtGlanceItem,
  },
  props: {
    attributes: {
      type: Array,
      required: true,
    },
  },
  created() {
    // assign icon and handle boolean types.
    // we don't need a reactive list, so we just create a constant Vue
    this.mappedAttributes = this.attributes.map((x) => {
      const attribute = { ...x };

      attribute.icon = ATTRIBUTE_ICON[attribute.slug];

      if (attribute.type === ATTRIBUTE_TYPE.BOOLEAN) {
        attribute.values = [];
      }

      return attribute;
    });
  },
};
